module.exports = __webpack_public_path__ + "img/90.512f2c0f.jpg";